<template>
  <form class="nameform m-center" @submit="submit">
    <div class="content flex flex-wrap">
      <h1 class="mb-6">Carta Prepagata</h1>

      <div
        class="w-full mb-3"
        v-for="term in cardTerms.filter(c => c.radio === false)"
        :key="term.id"
      >
        <a class="link" @click="openTerm(term.id)">{{ term.description }}</a>
      </div>

      <!-- TODO: check this loop out! we can have multiple items (?) and just one checkbox model (privacyConsentRead) -->
      <!-- TODO: is that correct? -->
      <div
        class="w-full mt-5 mb-3"
        v-for="term in cardTerms.filter(c => c.mandatory && c.radio === true)"
        :key="term.id"
      >
        <div class="tnb-checkbox">
          <div class="inline-flex">
            <input
              type="checkbox"
              id="privacyConsentRead"
              v-model="term.checked"
              @change="toggleCheckbox('privacyConsentRead')"
            />
            <label for="privacyConsentRead">{{ term.description }}</label>
          </div>
        </div>
      </div>

      <div class="w-full mt-8" v-for="term in nonMandatoryTerms" :key="term.id">
        <p class="text-grey mb-3">{{ term.description }}</p>
        <div class="tnb-input tnb-radio">
          <label :for="term.id">Dai il consenso</label>
          <div>
            <div class="tnb-radio-container mr-8">
              <input
                type="radio"
                id="yes"
                :name="term.id"
                :value="true"
                v-model="term.checked"
              />
              <label for="yes">Si</label>
            </div>
            <div class="tnb-radio-container">
              <input
                type="radio"
                id="no"
                :name="term.id"
                :value="false"
                v-model="term.checked"
              />
              <label for="no">No</label>
            </div>
          </div>
        </div>
      </div>

      <div
        class="w-full mb-3 mt-10 "
        v-for="document in cardDocuments"
        :key="document.id"
      >
        <a class="link" @click="openStaticContract(document.documentId)">{{
          document.description
        }}</a>
      </div>
      <div class="w-full mt-5 mb-3">
        <div class="tnb-checkbox">
          <div class="inline-flex">
            <input
              type="checkbox"
              id="generalConditionRead"
              @change="toggleCheckbox('generalConditionRead')"
            />
            <label for="generalConditionRead"
              >Dichiaro di aver preso visione dei Documenti precontrattuali e
              condizioni generali</label
            >
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <button class="btn" type="submit" :disabled="$v.$invalid">
        Prosegui
      </button>
    </div>
    <Modal id="viewDocModal" class="modal-centered" title="">
      <template v-slot:content>
        <div class="icon icon-docs icon--s m-center"></div>
        <b>Attenzione</b>
        <p class="mt-5">
          Per poter proseguire devi necessariamente consultare i "Documenti
          precontrattuali e condizioni generali della carta prepagata
          contrattualizzata"
        </p>
      </template>

      <template v-slot:buttons>
        <button
          class="btn"
          style="min-width: 150px"
          @click="() => $root.$emit('closeModal', 'viewDocModal')"
          type="button"
        >
          Ho capito!
        </button>
      </template>
    </Modal>
  </form>
</template>

<script>
import { sameAs } from "vuelidate/lib/validators";
import DocumentsService from "@/services/DocumentsService";
import RegistrationService from "@/services/RegistrationService";
import UtilityService from "@/services/UtilityService";
import Modal from "@/components/Modal";
import store from "@/store";

export default {
  name: "CardDocumentation",
  components: {
    Modal
  },
  data() {
    return {
      cardTerms: [],
      privacyTerm: {},
      nonMandatoryTerms: [],
      cardDocuments: [],
      flowDocs: [],
      privacyConsentRead: false,
      generalConditionRead: false,
      viewedDocumentation: false,
      staticContractRead: false
    };
  },
  validations: {
    privacyTerm: {
      checked: {
        sameAs: sameAs(() => true)
      }
    },
    generalConditionRead: {
      sameAs: sameAs(() => true)
    }
  },
  computed: {
    appReady() {
      return store.state.appReady;
    }
  },
  mounted() {
    if (this.appReady) {
      this.init();
    } else {
      this.$root.$on(`storeUpdated@setAppReady`, state => {
        if (state.appReady) {
          this.init();
        }
      });
    }
  },
  methods: {
    init() {
      DocumentsService.getTerms().then(response => {
        this.cardTerms = response.terms
          .filter(
            t =>
              t.id === 520 ||
              t.id === 121 ||
              t.id === 122 ||
              t.id === 123 ||
              t.id === 124
          )
          .map(c => {
            c.checked = false;
            return c;
          });

        this.privacyTerm = this.cardTerms.filter(t => t.id === 121)[0];
        this.nonMandatoryTerms = this.cardTerms.filter(
          c => c.mandatory === false && c.radio === true
        );
      });

      DocumentsService.getCurrentFlowStaticContracts().then(response => {
        this.cardDocuments = response.filter(d => d.type === "CSI_PCU_M");
      });
    },
    toggleCheckbox(checkboxKey) {
      this[checkboxKey] = !this[checkboxKey];
    },
    openTerm(id) {
      DocumentsService.openTerm(id);
      /* } */
    },
    openStaticContract(id) {
      this.staticContractRead = true;
      var url = DocumentsService.getStaticContractUrlFromId(id);
      DocumentsService.openDocument(url);
    },
    confirmViewDocumentation() {
      this.viewedDocumentation = true;
      this.$root.$emit("closeModal", "viewDocModal");
      this.submit();
    },
    submit() {
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      if (!this.staticContractRead) {
        this.$root.$emit("openModal", "viewDocModal");
        this.loading = false;
        return;
      }

      const radios = this.cardTerms.filter(t => t.radio === true);
      const req = {
        acceptedTermIds: radios.filter(r => r.checked).map(r => r.id),
        rejectedTermIds: radios.filter(r => !r.checked).map(r => r.id)
      };

      RegistrationService.setTerms(req).then(
        () => {
          this.stepCompleted();
        },
        error => {
          //TODO: error handling
          console.log(error);
          this.loading = false;
          UtilityService.showDefaultError(error);
        }
      );
    },
    stepCompleted() {
      this.$root.$emit("submitStep");
    }
  }
};
</script>
<style lang="less" scoped>
.tnb-radio {
  align-items: center;
  label {
    margin: 0;
  }
}
</style>
